import { useEffect, useRef } from "react";
import { Menu } from "semantic-ui-react";
import styled from "styled-components";
import layout from "../layout";
import devices from "../layout/devices";
import { colors, fonts } from "../style";

const Left = styled.div`
  min-width: 300px;
  width: 300px;
  height: 100%;
  box-sizing: border-box;
  background-color: ${colors.pageBackground};
  border-right: 1px solid ${colors.border};
  display: none;

  @media ${devices.tablet} {
    display: block;
  }
`;

const style = {
  wrapper: {
    display: "flex",
    height: `calc(100vh - ${layout.topbarHeight})`,
  },
  menu: {
    height: "100%",
    overflowY: "scroll",
    overflowX: "hidden",
  },
  title: {
    margin: 0,
    padding: "20px 16px 8px",
    fontFamily: fonts.system,
    fontSize: "15px",
    fontWeight: 600,
    color: colors.text,
  },
};

function SideScrollerLayout({ children }) {
  return <div style={style.wrapper}>{children}</div>;
}

function SideScrollerSidebar({ children }) {
  const menuRef = useRef(null);
  const scrollPositionRef = useRef(0);

  useEffect(() => {
    const menuElement = menuRef.current;
    if (menuElement) {
      // Restore scroll position
      menuElement.scrollTop = scrollPositionRef.current;

      // Save scroll position when scrolling
      const handleScroll = () => {
        scrollPositionRef.current = menuElement.scrollTop;
      };

      menuElement.addEventListener("scroll", handleScroll);
      return () => menuElement.removeEventListener("scroll", handleScroll);
    }
  }, []);

  return (
    <Left>
      <div style={style.menu}>
        <Menu
          vertical
          inverted
          className="cx-side-list"
          style={{ border: "none", width: "100%", background: "none" }}
        >
          {children}
        </Menu>
      </div>
    </Left>
  );
}

function SideScrollerSidebarItem({ children, ...otherProps }) {
  return <Menu.Item {...otherProps}>{children}</Menu.Item>;
}

// Heading at the top of the left list, e.g. "Call History"
function SideScrollerTitle({ children }) {
  return <h3 style={style.title}>{children}</h3>;
}

function SideScrollerContent({ children }) {
  return children;
}

export {
  SideScrollerContent,
  SideScrollerSidebar,
  SideScrollerSidebarItem,
  SideScrollerTitle,
};
export default SideScrollerLayout;
